import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import colunms from "../../../Components/assets/icons/LINES.png";
import pen from "../../../Components/assets/icons/pen.png";
import basket from "../../../Components/assets/icons/basket.png";
import search1 from "../../../Components/assets/icons/search.png";
import top from "../../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import circle from "../../assets/icons/circle.png";
import rigth from "../../assets/icons/rigth.png";
import save from "../../assets/icons/save.png";
import cancel from "../../assets/icons/cross.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
// *******************toster****************************
import toast, { Toaster } from "react-hot-toast";
import { Button, Form } from "react-bootstrap";
import { formatDate, formatDateTime, Select2Data } from "../../../utils/common";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Select from "react-select";
library.add(fas);

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    getDownloadDataExcel,
    Per_Page_Dropdown,
    IMG_URL,
  } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [searchDate, setSearchDate] = useState("");
  const [searchDateTo, setSearchDateTo] = useState("");

  const [searchDropPoint, setSearchDropPoint] = useState("");
  const [searchPickupPoint, setSearchPickupPoint] = useState("");
  const [searchCabType, setSearchCabType] = useState("");

  const [selectedData, setSelectedData] = useState();
  const [modalEditShow, setModalEditShow] = useState(false);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };
  const getDataAll = async () => {
    const response = await getData(
      `/exchange?page=${onPageChange}&per_page=${perPage}&term=${search}&from=${
        searchDate || ""
      }&to=${searchDateTo || ""}&searchDrop=${
        searchDropPoint || ""
      }&searchPickup=${searchPickupPoint || ""}&searchCabType=${
        searchCabType?.value || ""
      }`
    );
    await setData(response);
    setCurrentPage(response?.data?.currentPage);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    // setCurrentPage(response?.data?.);
    settotalPages(response?.data?.totalPages);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, show, show1, onPageChange]);

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/exchange/${id}`);
    setChangeStatus(response);
  };

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  // Select All Functionality
  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value))
        );
      }
    }
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/exchange/${recordToDeleteId}`);
      // notify("error", "Deleted Succefully");

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
    col10: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const HandleDownload = async () => {
    if (selectAllChecked.length == 0) {
      alert("Please Select Atleast One Record");
    } else {
      try {
        await getDownloadDataExcel(
          "/exchange/download",
          selectAllChecked,
          "Rider list"
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const [cabType, setCabtype] = useState([]);
  const GetAllCabType = async () => {
    const response = await getData("/all-cab-type-mobile");
    if (response?.success) {
      setCabtype(await Select2Data(response?.data, "cab_type_id"));
    }
  };
  useEffect(() => {
    GetAllCabType();
  }, []);

  const HandleDownloadRequirement = async () => {
    if (data?.data?.data.length == 0) {
      alert("Please Select Atleast One Record");
    } else {
      try {
        await getDownloadDataExcel(
          `/exchange/exchange-download?term=${search}&from=${
            searchDate || ""
          }&to=${searchDateTo || ""}&searchDrop=${
            searchDropPoint || ""
          }&searchPickup=${searchPickupPoint || ""}&searchCabType=${
            searchCabType?.value || ""
          }`,
          "",
          "Exchange"
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Exchange List"} link={"/home/inquiry"} />
        <section className="AdvanceDashboard">
          <div className="row ">
            <div className="col-xxl-12 col-xl-12  ">
              <div className="row MainRowsec">
                <section className="Tabels tab-radio tab-radio">
                  <div className="">
                    <div className="row">
                      <div className="d-flex">
                        <div className="add me-3"></div>
                      </div>
                      <div className="row mt-4">
                        <div className="  col-lg-12 col-md-12 col-12">
                          <div className="d-flex mb-3 align-items-center">
                            <div className="show me-2">
                              <p className="show  m-0">Show</p>
                            </div>
                            <div className="number me-2">
                              <select
                                className="form-select form-select-sm"
                                aria-label=".form-select-sm example"
                                onChange={(e) => setperPage(e.target.value)}
                              >
                                {option?.map((option) => (
                                  <option key={option} value={option}>
                                    {option}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="entries">
                              <p className="show  m-0">entries</p>
                            </div>
                            <div className="sowing ms-3 me-2">
                              <p className="show  m-0">{`Showing ${Math.min(
                                (currentPage - 1) * perPage + 1
                              )} to ${Math.min(
                                currentPage * perPage,
                                data?.data?.totalEntries
                              )} of ${data?.data?.totalEntries} entries`}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row align-items-end">
                        <div className="col-xxl-2 col-xl-3  col-lg-3  col-md-6 col-12 mt-md-0 mt-3 mb-2">
                          <div className="num me-2">
                            <Select
                              isSearchable
                              options={cabType}
                              value={searchCabType}
                              placeholder="Select Cab Type"
                              onChange={(e) => {
                                setSearchCabType(e);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-xxl-2 col-xl-3  col-lg-3  col-md-6 col-12 mt-md-0 mt-3 mb-2">
                          <div className="num me-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search User Name"
                              id=""
                              value={search}
                              onChange={(e) => {
                                setSearch(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-xxl-2 col-xl-3  col-lg-3  col-md-6 col-12 mt-md-0 mt-3 mb-2">
                          <div className="num me-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Pickup Point"
                              id=""
                              value={searchPickupPoint}
                              onChange={(e) => {
                                setSearchPickupPoint(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-xxl-2 col-xl-3  col-lg-3  col-md-6 col-12 mt-md-0 mt-3 mb-2">
                          <div className="num me-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Drop Point"
                              id=""
                              value={searchDropPoint}
                              onChange={(e) => {
                                setSearchDropPoint(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-xxl-2 col-xl-3  col-lg-3  col-md-6 col-12 mt-md-0 mt-3 mb-2">
                          from
                          <div className="num me-2">
                            {/* <label  className="form-label">From</label> */}
                            <input
                              type="date"
                              className="form-control"
                              placeholder="from"
                              value={searchDate}
                              onChange={(e) => {
                                setSearchDate(e.target.value);
                                setonPageChange(1);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-xxl-2 col-xl-3  col-lg-3  col-md-6 col-12 mt-md-0 mt-3 mb-2">
                          to
                          <div className="num me-2">
                            <input
                              type="date"
                              className="form-control"
                              placeholder="to"
                              value={searchDateTo}
                              onChange={(e) => {
                                setSearchDateTo(e.target.value);
                                setonPageChange(1);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-xxl-2 col-xl-3  col-lg-3  col-md-6 col-12 mt-md-0 mt-3 mb-2">
                          <div className="Search me-2">
                            <Button
                              type="button"
                              onClick={getDataAll}
                              className="btn btn-search w-100"
                            >
                              <img src={search1} className="search" alt="" />
                            </Button>
                          </div>
                        </div>
                        <div className="col-xxl-2 col-xl-3  col-lg-3  col-md-6 col-12 mt-md-0 mt-3 mb-2">
                          <div className="Search-1">
                            <button
                              type="button"
                              onClick={() => {
                                setSearch("");
                                setSearchDropPoint("");
                                setSearchPickupPoint("");
                                setSearchDateTo("");
                                setSearchDate("");
                                setSearchCabType("");
                                setReset(!reset);
                              }}
                              className="btn btn-reset w-100"
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                        <div className="d-flex col-xxl-3 col-xl-3  col-lg-4  col-md-5 col-12 mb-2">
                          <button
                            type="button"
                            className="btn btn-search w-100"
                            onClick={HandleDownloadRequirement}
                          >
                            Download excel
                            <FontAwesomeIcon
                              icon="fa-solid fa-file-lines"
                              className="pdf-icon ms-3"
                              variant="success"
                              // className="btn btn-view"
                            />
                          </button>
                        </div>
                        {/* <div className="d-flex col-xxl-3 col-xl-3  col-lg-4  col-md-5 col-12 mb-2">
                            <button
                              type="button"
                              className="btn btn-search w-100"
                              onClick={HandleDownload}
                            >
                              Download excel
                              <FontAwesomeIcon
                                icon="fa-solid fa-file-lines"
                                className="pdf-icon ms-3"
                                variant="success"
                                // className="btn btn-view"
                              />
                            </button>
                          </div> */}
                      </div>
                    </div>
                    <div className="border-line mt-3"></div>
                    <div className="row mt-3">
                      <div className="data table-responsive">
                        <Table striped bordered hover responsive center>
                          <thead>
                            <tr className="">
                              {visible.col1 && <th className="sr">S. No</th>}
                              {visible.col2 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "400px" }}
                                >
                                  Booking Id
                                </th>
                              )}
                              {visible.col10 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "400px" }}
                                >
                                  User Name
                                </th>
                              )}
                              {visible.col3 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "400px" }}
                                >
                                  Cab Type
                                </th>
                              )}
                              {visible.col4 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "400px" }}
                                >
                                  Trip Type
                                </th>
                              )}

                              {visible.col5 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "600px" }}
                                >
                                  Pickup Point
                                </th>
                              )}

                              {visible.col7 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "600px" }}
                                >
                                  Drop Point
                                </th>
                              )}
                              {visible.col8 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "600px" }}
                                >
                                  Date
                                </th>
                              )}
                              {visible.col9 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "600px" }}
                                >
                                  {" "}
                                  time
                                </th>
                              )}
                              {visible.col9 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "600px" }}
                                >
                                  {" "}
                                  CreatedAt
                                </th>
                              )}
                              {visible.col9 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "600px" }}
                                >
                                  {" "}
                                  Budget
                                </th>
                              )}
                              {visible.col6 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "600px" }}
                                >
                                  {" "}
                                  Action
                                </th>
                              )}
                              {/* {visible.col4 && <th className="active">Action</th>} */}
                            </tr>
                          </thead>
                          <tbody>
                            {data?.data?.data?.map((d, index) => {
                              return (
                                <tr className="" key={index}>
                                  {/* {visible.col0 && (
                                    <td>
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          value={d?.id}
                                          name="perselected"
                                          checked={selectAllChecked.includes(
                                            d?.id
                                          )}
                                          onChange={handleChange}
                                          id="flexCheckDefault"
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor="flexCheckDefault"
                                        ></label>
                                      </div>
                                    </td>
                                  )} */}
                                  {visible.col1 && <td>{++index}.</td>}
                                  {visible.col2 && <td>{d?.booking_id}</td>}
                                  {visible.col10 && (
                                    <td>{d?.user?.first_name}</td>
                                  )}
                                  {visible.col3 && <td>{d?.cab_type?.name}</td>}
                                  {visible.col4 && (
                                    <td>{d?.sub_category?.name}</td>
                                  )}
                                  {visible.col5 && <td>{d?.pick_up_point}</td>}
                                  {visible.col7 && <td>{d?.drop_point}</td>}

                                  {visible.col8 && <td>{d?.date}</td>}
                                  {visible.col9 && <td>{d?.time}</td>}
                                   {visible.col8 && <td>{formatDateTime(d?.createdAt)}</td>}
                                  {visible.col9 && <td>{d?.budget}</td>}
                                  {visible.col6 && (
                                    <td>
                                      <button
                                        onClick={() => {
                                          showDeleteRecord(
                                            d?.id,
                                            d?.booking_id
                                          );
                                        }}
                                        style={{ margin: "10px" }}
                                        type="button"
                                        className="btn btn-danger"
                                      >
                                        <img
                                          src={basket}
                                          className="pen"
                                          alt=""
                                        />
                                      </button>
                                      <Button
                                        variant="primary"
                                        onClick={() => {
                                          setSelectedData(d);
                                          setModalEditShow(true);
                                        }}
                                      >
                                        Exchange Give
                                      </Button>
                                    </td>
                                  )}
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                        {modalEditShow && selectedData && (
                          <div
                            className="modal fade show"
                            style={{ display: "block" }}
                          >
                            <div className="modal-dialog modal-dialog-centered">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title">
                                    Exchange Give Data
                                  </h5>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setModalEditShow(false)}
                                  ></button>
                                </div>
                                <div className="modal-body">
                                  <p>
                                    <strong>Pick Up Point</strong>{" "}
                                    {selectedData?.exchange_give?.pick_up_point}
                                  </p>
                                  <p>
                                    <strong>Dro Point</strong>{" "}
                                    {selectedData?.exchange_give?.drop_point}
                                  </p>
                                  <p>
                                    <strong>Date</strong>{" "}
                                    {selectedData?.exchange_give?.date}
                                  </p>
                                  <p>
                                    <strong>Time</strong>{" "}
                                    {selectedData?.exchange_give?.time}
                                  </p>
                                  <p>
                                    <strong>Cab Type</strong>{" "}
                                    {
                                      selectedData?.exchange_give?.cab_type
                                        ?.name
                                    }
                                  </p>
                                  <p>
                                    <strong>Description</strong>{" "}
                                    {selectedData?.exchange_give?.description}
                                  </p>
                                </div>
                                <div className="modal-footer">
                                  <button
                                    className="btn btn-secondary"
                                    onClick={() => setModalEditShow(false)}
                                  >
                                    Close
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        <Pagination_Holder
                          onPageChange={currentPage}
                          totalPages={totalPages}
                          handlePageChange={handlePageChange}
                        />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* <!-- Modal Delete --> */}
      <div className="upload-modal">
        <div
          className={`modal fade ${showDeleteModal ? "show" : ""}`}
          style={{ display: showDeleteModal ? "block" : "none" }}
          id="exampleModaldel"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h1 className="add-success text-center  mt-2">
                  Are you sure ?
                </h1>
                <p>
                  Do You Really Want to Delete These Record?
                  <br /> This Process CanNot Be Undone{" "}
                </p>
                <div className="button-holder text-center mt-2">
                  <button
                    className="btn btn-yes me-2"
                    onClick={handleDeleteRecord}
                  >
                    Yes
                  </button>
                  <button className="btn btn-no" onClick={handleDeleteCancel}>
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toaster position="top-right" />
    </>
  );
};

export default Tables;
